

export default[{
        path: '/thirdYear',
        component: () =>
            import ('@/pages/thirdYearMall/index/tabIndex'),
        meta: {
            title: '三年购'
        }
    },
    {
        path: '/shareThirdYear',
        component: () =>
            import ('@/pages/thirdYearMall/index/index'),
        meta: {
            title: '三年购'
        }
    },
    {
        path: '/stuff',
        component: () =>
            import ('@/pages/thirdYearMall/secondary/second-stuff'),
        meta: {
            title: ''
        }
    },
    {
        path: '/foremost',
        component: () =>
            import ('@/pages/thirdYearMall/secondary/second-foremost'),
        meta: {
            title: ''
        }
    },
    {
        path: '/stream',
        component: () =>
            import ('@/pages/thirdYearMall/secondary/second-stream'),
        meta: {
            title: ''
        }
    },
    {
        path: '/rules',
        component: () =>
            import ('@/pages/thirdYearMall/rules/rules'),
        meta: {
            title: ''
        }
    },
    {
        path: '/red-envelope',
        component: () =>
            import ('@/pages/envelope'),
        meta: {
            title: ''
        }

    },

{
    path: '/playcoin/share',
    component: () =>
        import('@/pages/playCoin/share'),
    meta: {
        title: '积分商城'
    }
},
{
    path: '/shareThirdYear',
    component: () =>
        import ('@/pages/thirdYearMall/index/index'),
    meta: {
        title: '三年购'
    }
},
{
    path: '/stuff',
    component: () =>
        import ('@/pages/thirdYearMall/secondary/second-stuff'),
    meta: {
        title: ''
    }
},
{
    path: '/foremost',
    component: () =>
        import ('@/pages/thirdYearMall/secondary/second-foremost'),
    meta: {
        title: ''
    }
},
{
    path: '/stream',
    component: () =>
        import ('@/pages/thirdYearMall/secondary/second-stream'),
    meta: {
        title: ''
    }
},
{
    path: '/rules',
    component: () =>
        import ('@/pages/thirdYearMall/rules/rules'),
    meta: {
        title: ''
    }
},
{
    path: '/red-envelope',
    component: () =>
        import ('@/pages/envelope'),
    meta: {
        title: ''
    }
}
]